<div class="container">
    <div class="card">
        <div class="card-body">
            <div class="panel panel-primary">
                <div class="panel-heading custom-panel">
                    <div class="titulo-painel-left">
                        <h2>Pacientes</h2>
                    </div>
                    <div class="menu-painel">
                        <button mat-stroked-button color="primary" (click)="add()" matTooltip="Criar">Novo
                        </button>
                    </div>
                </div>
                <div class="panel-body" (window:resize)="onResize($event)">

                    <form [formGroup]="formularioDeConsultaDePaciente" (ngSubmit)="onSubmit()">

                        <div class="form-row">

                            <mat-form-field class="form-group col-lg-4 col-md-12 col-sm-12 col-12">
                                <mat-label>Nome</mat-label>
                                <input matInput value="Nome" class="form-control" id="nome" trim="blur" name="nome"
                                    formControlName="nome" maxlength="60" upperCase>

                                <mat-error *ngIf="formularioDeConsultaDePaciente.controls.nome.hasError('minlength')">
                                    O campo Nome precisa conter mais do que 2 caracteres.
                                </mat-error>
                            </mat-form-field>

                            <mat-form-field class="form-group col-lg-3 col-md-4 col-sm-6 col-12">
                                <mat-label>CPF</mat-label>
                                <input matInput value="CPF" class="form-control" id="cpf" trim="blur" name="cpf"
                                    formControlName="cpf" maxlength="14" trim="blur" nccCpfCnpjMask>
                                <mat-error *ngIf="formularioDeConsultaDePaciente.controls.cpf.errors">
                                    O campo CPF está inválido.
                                </mat-error>
                            </mat-form-field>

                            <mat-form-field class="form-group col-lg-3 col-md-4 col-sm-6 col-12">
                                <mat-label>Data Nasc.</mat-label>
                                <input matInput [matDatepicker]="dataNascimentoDP" formControlName="dataNascimento"
                                    id="dataNascimento" name="dataNascimento" class="form-control">
                                <mat-datepicker-toggle matSuffix [for]="dataNascimentoDP"></mat-datepicker-toggle>
                                <mat-datepicker #dataNascimentoDP></mat-datepicker>

                                <mat-error
                                    *ngIf="formularioDeConsultaDePaciente.controls.dataNascimento.hasError('invalidDate')">
                                    O campo Data Nasc. está inválido.
                                </mat-error>
                            </mat-form-field>

                            <div class="form-group col-lg-2 col-md-4 col-sm-12 col-12" style="align-self: center;">
                                <button mat-raised-button color="success" type="submit" matTooltip="Consultar"
                                    [disabled]="!formularioDeConsultaDePaciente.valid" style="width: 100%;">
                                    Consultar
                                </button>
                            </div>

                        </div>

                    </form>

                    <table mat-table [dataSource]="dataSource" matSort class="table table-striped">
                        <ng-container matColumnDef="nome">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Nome </th>
                            <td mat-cell *matCellDef="let paciente"> {{paciente.nome}} </td>
                        </ng-container>

                        <ng-container matColumnDef="dataNascimento">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Data Nasc. </th>
                            <td mat-cell *matCellDef="let paciente"> {{paciente.dataNascimento | date:"dd/MM/yyyy"}}
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="cpf">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> CPF </th>
                            <td mat-cell *matCellDef="let paciente"> {{paciente.cpf | mask: '999.999.999-99'}}
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="foneResidencial">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Fone Residencial </th>
                            <td mat-cell *matCellDef="let paciente"> {{paciente.foneResidencial | mask:
                                mascaraFoneCustom(paciente.foneResidencial)}} </td>
                        </ng-container>

                        <ng-container matColumnDef="foneCelular">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Fone Celular </th>
                            <td mat-cell *matCellDef="let paciente"> {{paciente.foneCelular | mask:
                                mascaraFoneCustom(paciente.foneCelular)}} </td>
                        </ng-container>

                        <ng-container matColumnDef="details">
                            <th mat-header-cell *matHeaderCellDef class="table-column-center"> Ações </th>
                            <td mat-cell *matCellDef="let paciente" class="table-column-center">
                                <button mat-icon-button color="primary" (click)="details(paciente.id)"
                                    matTooltip="Detalhar">
                                    <mat-icon class="mat-18">info</mat-icon>
                                </button>
                                <button mat-icon-button color="primary" (click)="update(paciente.id)"
                                    matTooltip="Alterar">
                                    <mat-icon class="mat-18">edit</mat-icon>
                                </button>
                                <button mat-icon-button color="warn" (click)="confirmDelete(paciente.id)"
                                    matTooltip="Remover">
                                    <mat-icon class="mat-18">delete</mat-icon>
                                </button>
                            </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                    </table>
                    <mat-paginator [pageSize]="pageSize" [pageSizeOptions]="[10, 30, 50, 70, 100]" showFirstLastButtons>
                    </mat-paginator>
                </div>
            </div>
        </div>
    </div>
</div>
